import React from "react";

import { useLocation } from "react-router-dom";

import Icons from "../../../components/icons-helper";

import * as S from "./styles";

import IProps from "./props";

import { theme } from "../../../styles/theme";

const RenderItem: React.FC<IProps> = ({ item, isMenuOpen }) => {
  const [isSelected, setIsSelected] = React.useState<boolean>(false);

  const location = useLocation();

  React.useEffect(() => {
    setIsSelected(item?.route?.includes(location.pathname));
  }, [location.pathname, item.route]);

  return (
    <S.MenuItemsElement
      open={isMenuOpen}
      to={item?.route[0]}
      selected={isSelected}
      key={item.key}
    >
      <Icons
        name={item.icon}
        width={25}
        height={25}
        color={item?.color || theme.colors.primary}
      />
      <S.MenuSpanElement selected={isSelected} open={isMenuOpen}>
        {isMenuOpen ? item.title : ""}
      </S.MenuSpanElement>
    </S.MenuItemsElement>
  );
};

export default RenderItem;
